/* Fit-Inn Shop – Theme-Skripte (ohne Abhängigkeiten).
   Reihenfolge: Ansicht (hell/dunkel) · Menü · Warenkorb · Produktseite · Galerie · Kleinkram. */
(function () {
  'use strict';

  var cfg = window.fitinn || {};
  var doc = document;
  var root = doc.documentElement;
  var urlVariant = null; /* ?variant= beim Laden, bevor die Produktseite die URL umschreibt */
  try { urlVariant = new URLSearchParams(window.location.search).get('variant'); } catch (e) { urlVariant = null; }

  function qs(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  /* ---------------------------------------------------------------- Ansicht */
  var THEME_KEY = 'fitinn.theme';

  function resolveTheme(theme) {
    if (theme === 'system') {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return theme;
  }

  function applyTheme(theme) {
    root.dataset.theme = theme;
    root.dataset.resolved = resolveTheme(theme);
    qsa('[data-theme-set]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.themeSet === theme ? 'true' : 'false');
    });
    var toggle = qs('[data-theme-toggle]');
    if (toggle) {
      var target = root.dataset.resolved === 'dark' ? 'hellen' : 'dunklen';
      toggle.setAttribute('aria-label', 'Zur ' + target + ' Ansicht wechseln');
      toggle.setAttribute('title', 'Zur ' + target + ' Ansicht wechseln');
    }
  }

  function setTheme(theme) {
    try { localStorage.setItem(THEME_KEY, theme); } catch (e) { /* privater Modus */ }
    applyTheme(theme);
  }

  applyTheme(root.dataset.theme || 'dark');
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function () {
    if (root.dataset.theme === 'system') applyTheme('system');
  });

  doc.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-theme-toggle]');
    if (toggle) {
      setTheme(root.dataset.resolved === 'dark' ? 'light' : 'dark');
      return;
    }
    var set = event.target.closest('[data-theme-set]');
    if (set) setTheme(set.dataset.themeSet);
  });

  /* ------------------------------------------------------------------- Menü */
  var menuLastFocus = null;

  function menuParts() {
    return { panel: qs('[data-menu-panel]'), backdrop: qs('.site-header__backdrop'), burger: qs('[data-menu-open]') };
  }

  function openMenu() {
    var m = menuParts();
    if (!m.panel) return;
    menuLastFocus = doc.activeElement;
    m.panel.hidden = false;
    m.backdrop.hidden = false;
    m.burger.setAttribute('aria-expanded', 'true');
    doc.body.style.overflow = 'hidden';
    m.panel.focus();
  }

  function closeMenu() {
    var m = menuParts();
    if (!m.panel || m.panel.hidden) return;
    m.panel.hidden = true;
    m.backdrop.hidden = true;
    m.burger.setAttribute('aria-expanded', 'false');
    doc.body.style.overflow = '';
    if (menuLastFocus) menuLastFocus.focus();
  }

  doc.addEventListener('click', function (event) {
    if (event.target.closest('[data-menu-open]')) openMenu();
    else if (event.target.closest('[data-menu-close]')) closeMenu();
  });

  /* -------------------------------------------------------------- Warenkorb */
  var drawerOpen = false;
  var drawerLastFocus = null;

  function drawerParts() {
    var wrap = qs('#shopify-section-cart-drawer');
    return {
      wrap: wrap,
      panel: wrap && qs('[data-cart-panel]', wrap),
      backdrop: wrap && qs('.cart-drawer__backdrop', wrap)
    };
  }

  function applyDrawerState() {
    var d = drawerParts();
    if (!d.panel) return;
    d.panel.hidden = !drawerOpen;
    d.backdrop.hidden = !drawerOpen;
    doc.body.style.overflow = drawerOpen ? 'hidden' : '';
  }

  function openDrawer() {
    var d = drawerParts();
    if (!d.panel) { window.location.href = cfg.cartUrl; return; }
    drawerLastFocus = doc.activeElement;
    drawerOpen = true;
    applyDrawerState();
    d.panel.focus();
  }

  function closeDrawer() {
    if (!drawerOpen) return;
    drawerOpen = false;
    applyDrawerState();
    if (drawerLastFocus && drawerLastFocus.focus) drawerLastFocus.focus();
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(cfg.locale || 'de', { style: 'currency', currency: currency || cfg.currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* Balken „Einkaufsvorteile“: alter Füllstand bleibt kurz stehen, dann gleitet
     er auf den neuen Wert – sonst springt er beim Neu-Rendern der Sections. */
  function goalWidths() {
    var widths = {};
    qsa('[data-cart-goals]').forEach(function (el) {
      var fill = qs('[data-cart-goals-fill]', el);
      if (fill) widths[el.dataset.cartGoals] = fill.style.width;
    });
    return widths;
  }

  function animateGoals(before) {
    qsa('[data-cart-goals]').forEach(function (el) {
      var fill = qs('[data-cart-goals-fill]', el);
      var from = before[el.dataset.cartGoals];
      if (!fill || !from || from === fill.style.width) return;
      var to = fill.style.width;
      fill.style.transition = 'none';
      fill.style.width = from;
      void fill.offsetWidth;
      fill.style.transition = '';
      fill.style.width = to;
    });
  }

  function renderSections(sections) {
    var goalsBefore = goalWidths();
    Object.keys(sections || {}).forEach(function (id) {
      var wrap = qs('#shopify-section-' + id);
      if (!wrap || !sections[id]) return;
      var next = new DOMParser().parseFromString(sections[id], 'text/html');
      var inner = next.querySelector('.shopify-section') || next.body;
      wrap.innerHTML = inner.innerHTML;
    });
    applyDrawerState();
    animateGoals(goalsBefore);
  }

  function refreshCart() {
    return Promise.all([
      fetch(cfg.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      fetch(cfg.rootUrl + '?sections=cart-drawer,main-cart').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var cart = res[0];
      renderSections(res[1]);
      qsa('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      qsa('[data-cart-total]').forEach(function (el) { el.textContent = formatMoney(cart.total_price, cart.currency); });
      var btn = qs('[data-cart-open]');
      if (btn) btn.setAttribute('aria-label', 'Warenkorb öffnen, ' + cart.item_count + ' Artikel, ' + formatMoney(cart.total_price, cart.currency));
      return cart;
    });
  }

  function addToCart(form) {
    var data = new FormData(form);
    var errorBox = qs('[data-form-error]', form);
    if (errorBox) errorBox.hidden = true;
    var submit = qs('[type="submit"]', form);
    if (submit) submit.disabled = true;
    return fetch(cfg.cartAddUrl + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = res.body.description || res.body.message || 'Das Produkt konnte nicht hinzugefügt werden.';
          if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; }
          return null;
        }
        return refreshCart().then(openDrawer);
      })
      .catch(function () { form.submit(); })
      .then(function () { if (submit) submit.disabled = false; });
  }

  doc.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.matches && (form.matches('[data-ajax-add]') || form.matches('[data-product-form]'))) {
      event.preventDefault();
      addToCart(form);
    }
  });

  doc.addEventListener('click', function (event) {
    var open = event.target.closest('[data-cart-open]');
    if (open) {
      if (doc.body.classList.contains('template-cart')) return;
      event.preventDefault();
      openDrawer();
      return;
    }
    if (event.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    var change = event.target.closest('[data-cart-change]');
    if (change) {
      event.preventDefault();
      fetch(cfg.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: change.dataset.cartChange, quantity: parseInt(change.dataset.quantity, 10) })
      }).then(refreshCart).catch(function () { window.location.reload(); });
    }
  });

  doc.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeMenu();
    closeDrawer();
  });

  /* ----------------------------------------------------------- Produktseite */
  var productRoot = qs('[data-product-root]');
  if (productRoot) initProduct(productRoot);

  function initProduct(rootEl) {
    var variantsEl = qs('[data-product-variants]');
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);
    var form = qs('[data-product-form]', rootEl);
    var idInput = qs('[data-variant-id]', rootEl);
    var qtyInput = qs('[data-qty-input]', rootEl);

    function selectedOptions() {
      var groups = qsa('[data-option-group]', rootEl);
      return groups.map(function (g) {
        var on = qs('[aria-pressed="true"]', g);
        return on ? on.dataset.optionValue : null;
      });
    }

    function findVariant() {
      var sel = selectedOptions();
      if (!sel.length) return variants[0];
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return sel[i] === null || sel[i] === o; });
      });
    }

    function setText(sel, text) { var el = qs(sel, rootEl); if (el) el.textContent = text; }
    function setHidden(sel, hidden) { var el = qs(sel, rootEl); if (el) el.hidden = hidden; }

    function update() {
      var v = findVariant();
      var addBtn = qs('[data-add-btn]', rootEl);
      var label = qs('[data-add-label]', rootEl);
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (label) label.textContent = 'Nicht verfügbar';
        return;
      }
      idInput.value = v.id;
      setText('[data-price]', v.price);
      var hasOld = v.disc > 0;
      setText('[data-price-old]', v.compare);
      setHidden('[data-price-old]', !hasOld);
      setText('[data-price-disc]', hasOld ? '−' + v.disc + ' %' : '');
      setHidden('[data-price-disc]', !hasOld);
      setText('[data-unit-price]', v.unit || '');
      setHidden('[data-unit-price]', !v.unit);
      setText('[data-portion-price]', v.portion || '');
      setHidden('[data-portion-price]', !v.portion);
      setText('[data-net-content]', v.net ? ' · Nettofüllmenge ' + v.net : '');
      var stickyPrice = qs('[data-sticky-price]'); if (stickyPrice) stickyPrice.textContent = v.price;
      var stickyUnit = qs('[data-sticky-unit]'); if (stickyUnit) stickyUnit.textContent = v.unit || '';
      var stickyBtn = qs('[data-sticky-add]'); if (stickyBtn) stickyBtn.disabled = !v.available;
      var kopf = qs('[data-pdp-kopf]'); if (kopf && v.ton) kopf.style.setProperty('--pdp-ton', v.ton);
      qsa('[data-variant-block]').forEach(function (el) { el.hidden = String(el.dataset.variantBlock) !== String(v.id); });
      setHidden('[data-stock-in]', !v.available);
      setHidden('[data-stock-out]', v.available);
      if (addBtn) addBtn.disabled = !v.available;
      if (label) label.textContent = v.available ? 'In den Warenkorb' : 'Nicht lieferbar';

      qsa('[data-plan-price]', rootEl).forEach(function (el) {
        var id = el.dataset.planPrice;
        el.textContent = id && v.plans[id] ? v.plans[id] : v.price;
      });

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      if (window.fitinnGallery && window.fitinnGallery.goToVariant(v.id)) return;
      if (v.mediaId && window.fitinnGallery) window.fitinnGallery.goToMedia(v.mediaId);
    }

    rootEl.addEventListener('click', function (event) {
      var opt = event.target.closest('[data-option-value]');
      if (opt) {
        qsa('[data-option-value]', opt.parentNode).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        opt.setAttribute('aria-pressed', 'true');
        update();
        return;
      }
      if (event.target.closest('[data-qty-minus]')) {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      } else if (event.target.closest('[data-qty-plus]')) {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      }
    });

    /* Abo-Kacheln: gewählte Kachel markieren */
    var planChoices = qsa('[data-plan-choice]', rootEl);
    function markPlans() {
      planChoices.forEach(function (c) {
        var checked = qs('input', c).checked;
        c.setAttribute('data-selected', checked ? 'true' : 'false');
      });
    }
    planChoices.forEach(function (c) { qs('input', c).addEventListener('change', markPlans); });
    markPlans();

    if (form) update();
  }

  /* ---------------------------------------------------------------- Galerie */
  qsa('[data-gallery]').forEach(initGallery);

  function initGallery(gallery) {
    var stage = qs('[data-gallery-stage]', gallery);
    if (!stage) return;
    var track = qs('[data-gallery-track]', gallery);
    var count = parseInt(gallery.dataset.count, 10) || 1;
    var index = 0;
    var images = [];
    try { images = JSON.parse(qs('[data-gallery-images]', gallery).textContent).filter(Boolean); } catch (e) { images = []; }
    var quer = gallery.hasAttribute('data-quer');

    function goTo(next) {
      index = Math.min(Math.max(next, 0), count - 1);
      track.style.transform = 'translate3d(' + (-index * 100) + '%,0,0)';
      var prev = qs('[data-gallery-prev]', gallery);
      var nextBtn = qs('[data-gallery-next]', gallery);
      if (prev) prev.style.visibility = index === 0 ? 'hidden' : '';
      if (nextBtn) nextBtn.style.visibility = index === count - 1 ? 'hidden' : '';
      var counter = qs('[data-gallery-index]', gallery);
      if (counter) counter.textContent = index + 1;
      qsa('.product-gallery__dot', gallery).forEach(function (d, i) { d.classList.toggle('product-gallery__dot-active', i === index); });
      qsa('.product-gallery__thumb', gallery).forEach(function (t, i) { t.classList.toggle('product-gallery__thumb-active', i === index); });
    }

    gallery.addEventListener('click', function (event) {
      var go = event.target.closest('[data-gallery-go]');
      if (go) goTo(parseInt(go.dataset.galleryGo, 10));
      else if (event.target.closest('[data-gallery-prev]')) goTo(index - 1);
      else if (event.target.closest('[data-gallery-next]')) goTo(index + 1);
    });

    stage.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(index + 1); }
      else if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(index - 1); }
    });

    /* Wischen und Tippen: geöffnet wird nur bei echtem Tap (< 10 px, < 400 ms),
       nie beim Scrollen (pointercancel) oder horizontalen Wischen. */
    var TAP_MOVE = 10;
    var TAP_TIME = 400;
    var pt = null;
    var openerEl = null;
    stage.addEventListener('pointerdown', function (event) {
      if (event.target.closest('button')) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pt = { id: event.pointerId, x: event.clientX, y: event.clientY, t: Date.now(), mode: null, dx: 0 };
    });
    stage.addEventListener('pointermove', function (event) {
      if (!pt || event.pointerId !== pt.id) return;
      var dx = event.clientX - pt.x;
      var dy = event.clientY - pt.y;
      if (!pt.mode) {
        if (Math.abs(dx) > TAP_MOVE && Math.abs(dx) > Math.abs(dy)) {
          pt.mode = 'h';
          track.classList.remove('product-gallery__track-animated');
          try { stage.setPointerCapture(event.pointerId); } catch (e) { /* egal */ }
        } else if (Math.abs(dy) > TAP_MOVE) {
          pt.mode = 'v';
        }
      }
      if (pt.mode !== 'h') return;
      pt.dx = dx;
      var atEdge = (index === 0 && dx > 0) || (index === count - 1 && dx < 0);
      track.style.transform = 'translate3d(calc(' + (-index * 100) + '% + ' + (atEdge ? dx / 3 : dx) + 'px),0,0)';
    });
    stage.addEventListener('pointerup', function (event) {
      if (!pt || event.pointerId !== pt.id) return;
      var cur = pt;
      pt = null;
      track.classList.add('product-gallery__track-animated');
      if (cur.mode === 'h') {
        if (cur.dx <= -45) goTo(index + 1);
        else if (cur.dx >= 45) goTo(index - 1);
        else goTo(index);
        return;
      }
      if (cur.mode === 'v') return;
      var moved = Math.max(Math.abs(event.clientX - cur.x), Math.abs(event.clientY - cur.y));
      if (moved < TAP_MOVE && Date.now() - cur.t < TAP_TIME) {
        openerEl = stage;
        openLightbox();
      }
    });
    /* Abbruch (z. B. Browser übernimmt das Scrollen): nie öffnen. */
    function abortDrag() {
      if (!pt) return;
      var wasH = pt.mode === 'h';
      pt = null;
      track.classList.add('product-gallery__track-animated');
      if (wasH) goTo(index);
    }
    stage.addEventListener('pointercancel', abortDrag);
    stage.addEventListener('contextmenu', abortDrag);

    /* Vollbild */
    var box = qs('[data-lightbox]', gallery);
    var boxImg = box && qs('[data-lightbox-image]', box);
    var boxStage = box && qs('[data-lightbox-stage]', box);
    /* An body hängen: so liegt das Vollbild garantiert über Kopfleiste und Sticky-Kaufleiste. */
    if (box) doc.body.appendChild(box);
    var boxIndex = 0;
    var zoomed = false;
    var boxOpen = false;
    var pushed = false;
    var saved = null;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    function insideImage(x, y) {
      var r = boxImg.getBoundingClientRect();
      var nw = boxImg.naturalWidth || r.width;
      var nh = boxImg.naturalHeight || r.height;
      var k = Math.min(r.width / nw, r.height / nh);
      var w = nw * k;
      var h = nh * k;
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;
      return Math.abs(x - cx) <= w / 2 && Math.abs(y - cy) <= h / 2;
    }
    function showBox(i) {
      boxIndex = (i + images.length) % images.length;
      boxImg.src = images[boxIndex].src;
      boxImg.alt = images[boxIndex].alt;
      zoomed = false;
      boxImg.classList.remove('product-lightbox__zoomed');
      var c = qs('[data-lightbox-count]', box);
      if (c) c.textContent = (boxIndex + 1) + ' / ' + images.length;
    }
    function openLightbox(start) {
      if (!box || !images.length || boxOpen) return;
      boxOpen = true;
      showBox(typeof start === 'number' ? start : index);
      saved = {
        html: doc.documentElement.style.overflow,
        body: doc.body.style.overflow,
        touch: doc.body.style.overscrollBehavior
      };
      doc.documentElement.style.overflow = 'hidden';
      doc.body.style.overflow = 'hidden';
      doc.body.style.overscrollBehavior = 'none';
      box.hidden = false;
      try { history.pushState({ fitinnLightbox: true }, ''); pushed = true; } catch (e) { pushed = false; }
      var closeBtn = qs('[data-lightbox-close]', box);
      (closeBtn || box).focus();
    }
    function closeLightbox(fromPop) {
      if (!box || !boxOpen) return;
      boxOpen = false;
      box.hidden = true;
      if (saved) {
        doc.documentElement.style.overflow = saved.html;
        doc.body.style.overflow = saved.body;
        doc.body.style.overscrollBehavior = saved.touch;
        saved = null;
      }
      if (boxIndex < count) goTo(boxIndex);
      if (pushed && !fromPop) { pushed = false; try { history.back(); } catch (e) { /* egal */ } }
      pushed = false;
      var back = openerEl && doc.body.contains(openerEl) ? openerEl : qs('[data-gallery-zoom]', gallery);
      if (back) { try { back.focus({ preventScroll: true }); } catch (e) { /* egal */ } }
    }
    window.addEventListener('popstate', function () { if (boxOpen) closeLightbox(true); });

    var zoomBtn = qs('[data-gallery-zoom]', gallery);
    if (zoomBtn) zoomBtn.addEventListener('click', function () { openerEl = zoomBtn; openLightbox(); });
    /* Knöpfe mit data-gallery-open öffnen das Vollbild an ihrer Stelle (derzeit ungenutzt) */
    qsa('[data-gallery-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openerEl = btn; openLightbox(parseInt(btn.dataset.galleryOpen, 10) || 0); });
    });

    if (box) {
      box.addEventListener('click', function (event) {
        if (event.target.closest('[data-lightbox-close]')) closeLightbox();
        else if (event.target.closest('[data-lightbox-prev]')) showBox(boxIndex - 1);
        else if (event.target.closest('[data-lightbox-next]')) showBox(boxIndex + 1);
        else if (event.target === boxImg) {
          if (suppressClick) return;
          /* Tippen neben das Foto (Leerfläche im Vollbild) schließt, auf das Foto vergrößert (nur Maus). */
          if (!insideImage(event.clientX, event.clientY)) { closeLightbox(); return; }
          if (!canHover) return;
          zoomed = !zoomed;
          boxImg.classList.toggle('product-lightbox__zoomed', zoomed);
        } else if (event.target === boxStage || event.target === box) {
          if (!suppressClick) closeLightbox();
        }
      });
      box.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { event.stopPropagation(); closeLightbox(); }
        else if (event.key === 'ArrowRight') showBox(boxIndex + 1);
        else if (event.key === 'ArrowLeft') showBox(boxIndex - 1);
        else if (event.key === 'Tab') {
          var f = qsa('button', box).filter(function (b) { return b.offsetParent !== null; });
          if (!f.length) return;
          var first = f[0];
          var last = f[f.length - 1];
          if (event.shiftKey && (doc.activeElement === first || doc.activeElement === box)) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && doc.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });

      /* Wischen im Vollbild: nach unten schließt, seitlich blättert. */
      var suppressClick = false;
      var bp = null;
      boxStage.addEventListener('pointerdown', function (event) {
        if (event.target.closest('button')) return;
        bp = { id: event.pointerId, x: event.clientX, y: event.clientY };
        suppressClick = false;
      });
      boxStage.addEventListener('pointermove', function (event) {
        if (!bp || event.pointerId !== bp.id) return;
        var dx = event.clientX - bp.x;
        var dy = event.clientY - bp.y;
        if (Math.abs(dx) > TAP_MOVE || Math.abs(dy) > TAP_MOVE) suppressClick = true;
        if (!zoomed && dy > 0 && Math.abs(dy) > Math.abs(dx)) {
          boxImg.style.transition = 'none';
          boxImg.style.transform = 'translateY(' + dy + 'px)';
          boxImg.style.opacity = String(Math.max(0.3, 1 - dy / 400));
        }
      });
      function endBox(event, cancelled) {
        if (!bp || event.pointerId !== bp.id) return;
        var dx = event.clientX - bp.x;
        var dy = event.clientY - bp.y;
        bp = null;
        boxImg.style.transition = '';
        boxImg.style.transform = '';
        boxImg.style.opacity = '';
        if (cancelled || zoomed) return;
        if (dy > 80 && Math.abs(dy) > Math.abs(dx)) { suppressClick = true; closeLightbox(); }
        else if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) { suppressClick = true; showBox(boxIndex + (dx < 0 ? 1 : -1)); }
        if (suppressClick) setTimeout(function () { suppressClick = false; }, 350);
      }
      boxStage.addEventListener('pointerup', function (event) { endBox(event, false); });
      boxStage.addEventListener('pointercancel', function (event) { endBox(event, true); });
    }

    /* Querformat: erste Folie zeigt die gewählte Sorte; beim Wechsel Bild tauschen und dorthin springen */
    var variantMedia = {};
    try { variantMedia = JSON.parse(qs('[data-variant-media]', gallery).textContent); } catch (e) { variantMedia = {}; }
    var variantSlide = qs('[data-variant-slide]', gallery);
    var variantImg = variantSlide && qs('img', variantSlide);
    var variantCur = variantSlide ? String(variantSlide.dataset.mediaId || '') : '';
    function cdnWidth(url, w) { return /[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, '$1' + w) : url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
    /* Sorten-Sets: beim Sortenwechsel alle Folien, Punkte und die Vollbild-Liste gegen das Set der Sorte tauschen */
    var variantSets = null;
    if (gallery.hasAttribute('data-sorten-sets')) {
      try { variantSets = JSON.parse(qs('[data-variant-galerie]', gallery).textContent); } catch (e) { variantSets = null; }
    }
    var setCur = gallery.dataset.variantId || '';
    function showVariantSet(variantId) {
      var set = variantSets && variantSets[String(variantId)];
      if (!set || !set.length) return false;
      if (setCur !== String(variantId)) {
        setCur = String(variantId);
        var sizes = gallery.classList.contains('pdp-quer--quadrat') ? '(max-width: 980px) 100vw, 600px' : '(max-width: 980px) 100vw, 720px';
        track.innerHTML = '';
        set.forEach(function (bild, i) {
          var slide = doc.createElement('div');
          slide.className = 'product-gallery__slide pdp-quer__slide';
          var img = doc.createElement('img');
          img.className = 'pdp-quer__bild';
          img.alt = bild.alt || '';
          img.draggable = false;
          img.loading = i === 0 ? 'eager' : 'lazy';
          img.width = 2048;
          img.height = 2048;
          img.sizes = sizes;
          img.srcset = [600, 900, 1200, 1800, 2400].map(function (w) { return cdnWidth(bild.src, w) + ' ' + w + 'w'; }).join(', ');
          img.src = cdnWidth(bild.src, 1200);
          slide.appendChild(img);
          track.appendChild(slide);
        });
        /* Vollbild-Liste: Folien der Sorte vorn, die Fotos dahinter bleiben */
        images = set.map(function (b) { return { src: b.src, alt: b.alt || '' }; }).concat(images.slice(count));
        count = set.length;
        gallery.dataset.count = String(count);
        var dots = qs('.pdp-quer__dots', gallery);
        if (dots) {
          dots.innerHTML = '';
          for (var d = 0; d < count; d++) {
            var dot = doc.createElement('button');
            dot.type = 'button';
            dot.className = 'product-gallery__dot';
            dot.dataset.galleryGo = String(d);
            dot.setAttribute('aria-label', 'Bild ' + (d + 1));
            dots.appendChild(dot);
          }
        }
      }
      goTo(0);
      return true;
    }
    window.fitinnGallery = {
      goToVariant: function (variantId) { return showVariantSet(variantId); },
      goToMedia: function (mediaId) {
        if (quer) {
          var url = variantMedia[String(mediaId)];
          if (!url || !variantImg) return;
          if (variantCur !== String(mediaId)) {
            variantCur = String(mediaId);
            variantImg.classList.add('is-wechsel');
            variantImg.onload = function () { variantImg.classList.remove('is-wechsel'); };
            variantImg.srcset = [400, 600, 900, 1200].map(function (w) { return cdnWidth(url, w) + ' ' + w + 'w'; }).join(', ');
            variantImg.src = cdnWidth(url, 1200);
            if (images[0]) images[0].src = cdnWidth(url, 2000);
            setTimeout(function () { variantImg.classList.remove('is-wechsel'); }, 600);
          }
          goTo(0);
          return;
        }
        var slides = qsa('.product-gallery__slide', gallery);
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].dataset.mediaId) === String(mediaId)) { goTo(i); return; }
        }
      }
    };
    goTo(0);
    /* Link mit ?variant=… öffnet direkt das Bild der Sorte */
    try {
      var vid = urlVariant;
      var vdata = qs('[data-product-variants]');
      if (vid && vdata) {
        JSON.parse(vdata.textContent).forEach(function (v) {
          if (String(v.id) !== String(vid)) return;
          if (window.fitinnGallery.goToVariant(v.id)) return;
          if (v.mediaId) window.fitinnGallery.goToMedia(v.mediaId);
        });
      }
    } catch (e) { /* egal */ }
  }

  /* ------------------------------------------------ Produktseite: Zusatzteile */
  /* Gläsernes Etikett: Nährstoff antippen */
  doc.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-glass-tab]');
    var more = event.target.closest('[data-glass-more]');
    if (!tab && !more) return;
    var label = event.target.closest('[data-glass-label]');
    if (!label) return;
    if (more) {
      qsa('[data-glass-mehr]', label).forEach(function (el) { el.hidden = false; });
      more.hidden = true;
      return;
    }
    var idx = tab.dataset.glassTab;
    qsa('[data-glass-tab]', label).forEach(function (t) {
      var on = t.dataset.glassTab === idx;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.classList.toggle('pdp__label-chip-aktiv', on);
    });
    qsa('[data-glass-panel]', label).forEach(function (p) { p.hidden = p.dataset.glassPanel !== idx; });
  });

  /* Sprungleiste: Einträge aus den Abschnittsköpfen, aktives Kapitel markieren */
  var pdpNav = qs('[data-pdp-nav]');
  if (pdpNav) {
    var track = qs('[data-pdp-nav-track]', pdpNav);
    var heads = qsa('[data-pdp-ziel]');
    heads.forEach(function (h) {
      var a = doc.createElement('a');
      a.href = '#' + h.id;
      a.className = 'pdp__sprung-link';
      a.dataset.ziel = h.id;
      a.textContent = h.dataset.pdpZiel;
      track.appendChild(a);
    });
    if (heads.length) {
      pdpNav.hidden = false;
      var setActive = function (id) {
        qsa('.pdp__sprung-link', track).forEach(function (a) {
          var on = a.dataset.ziel === id;
          a.classList.toggle('pdp__sprung-aktiv', on);
          if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        });
      };
      setActive(heads[0].id);
      if ('IntersectionObserver' in window) {
        var sections = heads.map(function (h) { return h.closest('section') || h; });
        var offset = Math.round((parseFloat(getComputedStyle(root).getPropertyValue('--header-height')) || 65) + pdpNav.getBoundingClientRect().height + 8);
        var io = new IntersectionObserver(function (entries) {
          var hit = entries.filter(function (e) { return e.isIntersecting; })
            .sort(function (a, b) { return b.boundingClientRect.top - a.boundingClientRect.top; })[0];
          if (hit) setActive(heads[sections.indexOf(hit.target)].id);
        }, { rootMargin: '-' + offset + 'px 0px -70% 0px', threshold: 0 });
        sections.forEach(function (sec) { io.observe(sec); });
      }
    }
  }

  /* Schmale Kaufleiste, sobald die Kaufzeile oben aus dem Bild ist */
  var stickyBar = qs('[data-sticky-bar]');
  var buyRow = qs('.pdp__buy-row');
  if (stickyBar && buyRow && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var open = !e.isIntersecting && e.boundingClientRect.top < 0;
      stickyBar.classList.toggle('pdp__sticky-bar-offen', open);
      stickyBar.setAttribute('aria-hidden', open ? 'false' : 'true');
      var b = qs('[data-sticky-add]', stickyBar); if (b) b.tabIndex = open ? 0 : -1;
    }, { rootMargin: '-56px 0px 0px 0px' }).observe(buyRow);
    doc.addEventListener('click', function (event) {
      if (!event.target.closest('[data-sticky-add]')) return;
      var form = qs('[data-product-form]');
      if (form && form.requestSubmit) form.requestSubmit(); else if (form) form.submit();
    });
  }

  /* ------------------------------------------------------ Startseiten-Werbung */
  doc.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-werbe-chip]');
    if (!chip) return;
    var box = chip.closest('[data-werbung]');
    if (!box) return;
    var idx = chip.dataset.werbeChip;
    qsa('[data-werbe-chip]', box).forEach(function (c) {
      var on = c.dataset.werbeChip === idx;
      c.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on) c.setAttribute('data-aktiv', ''); else c.removeAttribute('data-aktiv');
    });
    qsa('[data-werbe-bild]', box).forEach(function (img) {
      var on = img.dataset.werbeBild === idx;
      img.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) { img.setAttribute('data-aktiv', ''); img.loading = 'eager'; } else img.removeAttribute('data-aktiv');
    });
    qsa('[data-werbe-detail]', box).forEach(function (el) { el.hidden = el.dataset.werbeDetail !== idx; });
    qsa('[data-werbe-titel]', box).forEach(function (el) {
      var on = el.dataset.werbeTitel === idx;
      el.hidden = !on;
      if (on) box.style.setProperty('--werbe-ton', el.dataset.ton);
    });
  });

  /* -------------------------------------------------------------- Kleinkram */
  doc.addEventListener('change', function (event) {
    var sel = event.target.closest && event.target.closest('[data-sort-select]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  doc.addEventListener('click', function (event) {
    if (event.target.closest('[data-cookie-settings]')) {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.showPreferences === 'function') api.showPreferences();
      return;
    }
    var recover = event.target.closest('[data-recover-toggle]');
    if (recover) {
      event.preventDefault();
      var box = qs('#recover');
      if (box) box.hidden = !box.hidden;
    }
  });

  doc.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.dataset && form.dataset.confirm && !window.confirm(form.dataset.confirm)) event.preventDefault();
  });
})();
